<template>
   <div class="modelTitle">
      <div class="modelborder"></div>
      <div class="modelname">
        <b class='title1'>{{title1}}</b>
        <b class='title2'>{{title2}}</b>
      </div>
   </div>
</template>
<script>
export default {
  name: "minetitle",
  props: ["title1","title2"],
  data() {
    return {
        
    };
  },
  components: {},
  watch: {},
  computed: {},
  mounted() {
   
  },
  methods: {
  
   
  },
  
};
</script>

<style scoped>
  .modelTitle{
      width:100%;
      max-width:1600px;
      margin:0 auto;
      position: relative;
      z-index: 2;
  }
  .modelborder{
    width: 49px;
    height: 7px;
    background: linear-gradient(270deg, #1A64E4, #589EF8);
    box-shadow: 1px 2px 9px 0px rgba(47, 120, 235, 0.65);
    border-radius: 4px;
    margin-bottom:15px;
  }
  .modelname{
    margin-bottom:28px;
  }
  .title1{
    height: 38px;
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-right:28px;
    font-weight: 500;
  }
  .title2{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }



</style>
